import React, { FC } from 'react';
import { ButtonProps, ButtonUnstyled, Icon } from '@lambdacurry/component-library';
import classNames from 'classnames';
import './alert-text-button.scss';

interface AlertTextButton extends ButtonProps {
  className?: string;
  onClick: () => void;
}

export const AlertTextButton: FC<AlertTextButton> = ({ className, onClick, children, ...props }) => {
  return (
    <ButtonUnstyled
      {...props}
      className={classNames('alert-text-button !underline uppercase', className)}
      onClick={onClick}
    >
      <Icon className="mr-2" name="alert" aria-hidden="true" />
      {children}
    </ButtonUnstyled>
  );
};
